//COMMON
export const RECORD_FOUND = { code: 1000, message: "Data found" };
export const NO_RECORD_FOUND = { code: 1001, message: "Data not found" };
export const VALIDATIONS_ERROR = { code: 1003, message: null };
export const UNEXPECTED_ERROR = { code: 1004, message: null };

//USER
export const USER_LOGIN_EXISTS = { code: 2007, message: null };
export const USER_SETTINGS_UPDATED = { code: 2019, message: null };
export const USER_CREATED = { code: 2031, message: null };
export const USER_EDITED = { code: 2033, message: null };
export const USER_FARM_ASSIGNED = { code: 2035, message: null };
export const USER_DELETED = { code: 2037, message: null };
export const USER_PASSWORD_RESETED = { code: 2039, message: null };
export const USER_INVALID_CURRENT_PASSWORD = { code: 2041, message: null };
export const USER_AUTH_ADDED = { code: 2042, message: null };
export const USER_AUTH_EXISTS = { code: 2044, message: null };
export const USER_ROLE_PERMISSION_UPDATED = { code: 2045, message: null };
export const USER_PERMISSION_UPDATED = { code: 2047, message: null };
export const USER_CONFIGURATION_UPDATED = { code: 2049, message: null };

//TOKEN
export const TOKEN_EXPIRED = { code: 1006, message: null };
export const UNAUTHORISEDUSER = { code: 1005, message: null };
export const AUTHENTICATION_SUCCESS = { code: 2004, message: null };
export const AUTHENTICATION_FAILED = { code: 2005, message: null };

//CHAT
export const ADDED_FAVORITE = { code: 6001, message: null };

//FARM
export const FARM_ACTIVATED = { code: 2016, message: null };
export const FARM_SWITCHED = { code: 2018, message: null };
export const FARM_CREATED = { code: 3000, message: null };
export const FARM_EDITED = { code: 3009, message: null };
export const FARM_ARCHIVED = { code: 3021, message: null };
export const FARM_UNARCHIVED = { code: 3023, message: null };
export const FARM_NOTIFICATION_UPDATED = { code: 3027, message: null }
export const FARM_NOTIFICATION_UPDATE_FAILED = { code: 3028, message: null }
export const FARM_ADDRESS_UPDATED = { code: 3029, message: null }
export const FARM_ADDRESS_UPDATE_FAILED = { code: 3030, message: null }

// ORGANIZATION
export const ORGANIZATION_SAVED = { code: 3011, message: "Organization saved successfully" };
export const ORGANIZATION_DELETED = { code: 3013, message: null };

//EQUIPMENT
export const EQUIPMENT_CREATED = { code: 4000, message: null };
export const EQUIPMENT_EDITED = { code: 4002, message: null };
export const EQUIPMENT_DELETED = { code: 4004, message: null };

//EQUIPMENT GROUP
export const EQUIPMENT_GROUP_CREATED = { code: 4006, message: null };
export const EQUIPMENT_GROUP_EDITED = { code: 4009, message: null };
export const EQUIPMENT_GROUP_DELETED = { code: 4011, message: null };
export const EQUIPMENT_GROUP_RATE_SAVE = { code: 4013, message: 'Equipments Rate saved successfully' };

//CREW
export const CREW_CREATED = { code: 5000, message: null };
export const CREW_EDITED = { code: 5002, message: null };
export const CREW_DELETED = { code: 5004, message: null };
export const CREW_ENDED = { code: 5025, message: null };

//PERSON
export const PERSONAL_CREATED = { code: 2051, message: null };
export const PERSONAL_EDITED = { code: 2053, message: null };
export const PERSONAL_DELETED = { code: 2055, message: null };

//MAP
export const NO_EG_FOUND = { message: 'No equipment group(s) found' };

//REPORT
export const REPORT_GENERATED = { code: 6000, message: null };

//LOAD
export const LOAD_DELETED = { code: 4019, message: null };
export const LOAD_APPROVED = { code: 4023, message: 'Load approved successfully' };
export const LOAD_APPROVAL_CANCELLED = { code: 4023, message: 'Approval cancelled' };
export const LOAD_COMPLETED = { code: 4023, message: 'Load completed successfully' };
export const MOVE_LOAD_INCOMPLETE = { code: 4023, message: 'Load moved to queue.' };
export const LOAD_EDITED = { code: 4028, message: null };
export const LOAD_ADDED = { code: 4021, message: null };
export const LOAD_NOTES_SAVED = { code: 4034, message: 'Load notes saved successfully' };
export const BULK_LOAD_SAVED = { code: 4023, message: 'Load added successfully' }
export const BULK_LOAD_EDITED = { code: 4028, message: 'Load(s) saved successfully' }
export const LOAD_RESTORED = { code: 4045, message: null };

//HARDWARE
export const UNASSIGN_CANCODE = { code: 8003, message: null };

//GEO
export const GEO_REGION_BULK_EDIT_SAVED = { code: 7004, message: null };
export const GEO_REGION_DELETE = { code: 7002, message: null };
export const GEO_STORAGE_LOCATION_BULK_SAVED = { code: 7006, message: null };
export const GEO_REGION_RESTORE = { code: 7009, message: null };
export const FIELD_STATUS_UPDATED = { code: 7011, message: null };
export const DELETE_GEO_SHAPE = { code: 7014, message: null };

//NETWORK TYPE
export const ADD_NETWORK = { code: 11000 };
export const NETWORK_ASSIGN = { code: 11003 };

//Scout Group
export const SAVE_SCOUT_GROUP = { code: 12002 };
export const DELETE_SCOUT_GROUP_SUCCESS = { code: 12004 }

// RATE SCHEDULE
export const DELETE_RATE = { code: 14002, message: null }

//SCALE DEVICE
export const SAVE_SCALE_DEVICE = { code: 16000, message: "Scale device saved successfully" }
export const DELETE_SCALE_DEVICE = { code: 16002, message: "Scale device deleted successfully" }

export const UPDATE_SCALE_DEVICE = { code: 16004, message: "Scale device updated successfully" }